<app-header [isPublic]="true"></app-header>
<div class="container-fluid content">
<h3 class="pt-3">You have been signed out</h3>
<p>You have been signed out from KM. <a class="" [routerLink]="['/login']">Click to login</a></p>
</div>
<footer class="footer">
  <app-footer></app-footer>
</footer>
